export const canaryBrand = '#FEED5A';
export const canaryMedium = '#F8E40F';
export const canaryDark = '#EFD700';

export const blue10 = '#EDF4FE';
export const blue20 = '#DCE9FD';
export const blue30 = '#C5DBFB';
export const blue40 = '#9DC3F8';
export const blue50 = '#75ABF5';
export const blue60 = '#4E93F3';
export const blue70 = '#3E7CD1';
export const blue80 = '#2662AF';
export const blue90 = '#1F4F8E';
export const blue100 = '#00234B';

export const white = '#FFF';

export const slate10 = '#F7F8F9';
export const slate20 = '#EFF1F3';
export const slate30 = '#D7DBE1';
export const slate40 = '#B0B9C4';
export const slate50 = '#96A2B1';
export const slate60 = '#7C899A';
export const slate70 = '#6A788A';
export const slate80 = '#455263';
export const slate90 = '#36414E';
export const slate100 = '#252D37';

export const negativeBG = '#FFECEB';
export const negativeLight = '#E3544B';
export const negativeMedium = '#D93B33';
export const negativeDark = '#C2251D';

export const noticeBG = '#E5D4FA';
export const noticeLight = '#A771ED';
export const noticeMedium = '#9050E0';
export const noticeDark = '#6E2BC2';

export const positiveBG = '#C0EFE4';
export const positiveLight = '#1BCEA3';
export const positiveMedium = '#00B288';
export const positiveDark = '#00755A';

/**
 * Do not use these colors for new features.
 * These are depreacated colors that will be deleted very soon.
 * We are adding these temporarily so we can migrate to the new color
 * palate while Design decide on the best replacements for depreacated colors.
 */
export const DEPRECATED = {
    legacyBlue: '#4467b1',
    blueTint2: '#d8e5f4',
    tertiaryOrange: '#f7955a',
    tertiaryCoral: '#ff6473',
    neutral1: '#f7f7f7',
    neutral2: '#e0e0e0',
    neutral3: '#9e9e9e',
    neutral4: '#616161',
    neutral5: '#212121',
    feedbackWarning: '#ff0000',
    feedbackSuccess: '#00ae26',
};
